/* eslint-disable react/prop-types */
import React from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import {
	Alert,
	Snackbar,
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	InputLabel,
	Menu,
	MenuItem,
	Modal,
	Typography,
	useMediaQuery,
	Tooltip,
	TextField,
	CircularProgress,
	InputAdornment,
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';

import { useTheme } from '@mui/material/styles';

import bundleImg from '../../../../assets/logos/bundlesimg.png';

import hospitalimg from '../../../../assets/logos/locationIcon.png';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
	addLocation,
	getLocation,
	updateLocation,
	getAlllocations,
} from '../../../services/api/apiManager';
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Call, CallSplitRounded } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import MaskedInput from 'react-text-mask';
// const options = ['Edit', 'Delete'];

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	// width: '40%',
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	borderRadius: '10px',
};

function HospitalList(props) {
	// Using Local-Storage Pratice-ID
	const practice_id = localStorage.getItem('practice_id');

	// Snackbar States
	const [severity, setSeverity] = useState('success'); // Default severity
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [loading, setLoading] = useState(false);
	const [fieldRequiredError, setFieldRequiredError] = useState(false);
	// open snakbar
	const handleClickSnackbar = () => {
		setOpenSnackbar(true);
	};
	//   close Snackbar
	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	const schema = Yup.object().shape({
		// Name: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		Name: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		Type: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		City: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		State: Yup.string().matches(/^[a-zA-Z]+$/, 'Alphabets only'),
		Contact: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid '
		),
		NPI: Yup.string().matches(/^\d+$/, 'Numbers only '),
		Zip: Yup.string().matches(/^\d+$/, 'Numbers only '),
	});
	const [errors, setErrors] = useState({});
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setLocation((prev) => ({
			...prev,
			[name]: value,
		}));
		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};
	const handleEditModal = (e) => {
		const { name, value } = e.target;
		setEditData((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};

	const targetEditModal = (event) => {
		event.preventDefault();
		setEditData({
			...editData,
			[event.target.name]: event.target.value,
		});
	};

	const defaultTheme = createTheme();
	const [locations, setLocations] = useState([]);

	const [location, setLocation] = useState({
		Name: '',
		practice_id: practice_id,
		Type: '',
		NPI: '',
		Contact: '',
		Address: '',
		City: '',
		State: '',
		Zip: '',
	});

	// Edit Modal Function States
	const [editValues, setEditValues] = useState({
		Name: '',
		Type: ' ',
		NPI: '',
		Contact: '',
		Address: '',
		City: '',
		State: '',
		Zip: '',
	});

	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	// const handleClose = () => setOpen(false);

	// Edit Modal States
	const [editOpen, setEditOpen] = useState(false);

	// Edit ID State
	const [editData, setEditData] = useState([]);
	const [filterPractice, setFilterPractice] = useState();

	// Delete Data States
	const [deleteID, setDeleteID] = useState();
	const [deleteUser, setDeleteUser] = useState();
	// Dialog State
	const theme = useTheme();
	const [dialogOpen, setDialogOpen] = React.useState(false);
	const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	const [anchorEl, setAnchorEl] = useState(null);

	const [selectedIndex, setSelectedIndex] = useState(null);

	const fetchLocations = async () => {
		setLoading(true);
		try {
			const response = await getLocation();
			if (response?.status === 200) {
				setLocations(response?.data);
				setLoading(false);
			}
		} catch (error) {
			console.error('Error fetching locations:', error);
		}
	};
	const addlocationData = async () => {
		try {
			if (
				!location.Name ||
				!location.NPI ||
				!location.Type ||
				!location.Contact ||
				!location.City ||
				!location.State ||
				!location.Zip
			) {
				setFieldRequiredError(true);
			}
			await schema.validate(location, {
				abortEarly: false,
			});

			const response = await addLocation(location);
			if (response?.status === 201) {
				setLocation(response?.data);
				setOpen(false);
				setLocation({
					Name: '',
					practice_id: practice_id,
					Type: ' ',
					NPI: '',
					Contact: '',
					Address: '',
					City: '',
					State: '',
					Zip: '',
				});
				fetchLocations();
				if (props?.openModalIntialy == 'openModal') {
					props?.renderHandleFromChild('hospital');
				}

				// Open Snackbar Alert
				handleClickSnackbar();
				// Snackbar Color Show
				setSeverity('success');
				// 10 Seconds Show Snackbar
				setTimeout(() => {
					setOpenSnackbar(false);
				}, 1000);
			} else {
				setLocation([]);
			}
		} catch (error) {
			console.error('Error adding locaiton:', error);
		}
	};

	const handleClick = (event, index, data) => {
		setAnchorEl(event.currentTarget);
		// console.log('Index Value: ', index, 'Data: ', data);
		setSelectedIndex(index);
		// handleEditData(data);
	};

	// Function -- Filter Practice Id
	const filterPracticeID = async () => {
		// setFilterPractice([]);
		const filterData = locations?.filter((item) => {
			return item?.practice_id == practice_id;
		});
		setFilterPractice(filterData);
	};

	// Function -- Edit Data
	const handleEditData = (data) => {
		setEditOpen(true); // Open Modal here

		setEditData(data); // Set Practice ID Data
		// console.log( "Each Row Data: ", editData ) ;

		setAnchorEl(null); // when click edit then pop-up remove here
	};

	// Update Modal Values Function -- Edit Function
	const editDataObj = {
		// 'id': editData?.id,
		practice_id: practice_id,
		Name: editData?.Name,
		NPI: editData?.NPI,
		Type: editData?.Type,
		Contact: editData?.Contact,
		Address: editData?.Address,
		City: editData?.City,
		State: editData?.State,
		Zip: editData?.Zip,
	};
	const UpdateModalValues = async (editDataObj) => {
		try {
			// Validate the editDataObj using Yup schema
			await schema.validate(editData, { abortEarly: false });

			// If validation passes, proceed with the updateLocation API call
			const resp = await updateLocation(editData.id, editDataObj);

			if (resp?.request?.status === 200) {
				// Update, Then Close Modal
				setEditOpen(false);
				// Open Snackbar Alert
				handleClickSnackbar();
				// Snackbar Color Show
				setSeverity('info');

				// Fetch new data after successful update
				const newData = await fetchLocations();
				// Close Snackbar after 1 second
				setTimeout(() => {
					setOpenSnackbar(false);
				}, 1000);
			} else {
				// Handle other functionality here
			}
		} catch (error) {
			// Yup validation failed
			// console.error('Yup validation failed:', error);
			// Handle Yup validation error here, such as displaying error messages to the user
		}
	};

	// Dialog Functions Here
	const handleDialogClose = () => {
		setDialogOpen(false);
	};

	const deleteCancelPopup = () => {
		setDeletePopupOpen(false);
	};

	const handleDialogOpen = () => {
		setDialogOpen(true);
	};

	// Function For Delete Confirmation Message
	const handleDelete = (deleteData) => {
		setDeleteUser(deleteData?.Name);
		setDeleteID(deleteData?.id);
		setDeletePopupOpen(true);
	};
	// Delete Object
	const deleteStatus = {
		Deleted: true,
	};
	// Function -- Delete Data
	const handleDeleteObj = async (deleteID) => {
		// open pop-up here
		setAnchorEl(null);

		// Delete Function
		const resp = await updateLocation(deleteID, deleteStatus);
		if (resp?.request?.status === 200) {
			setDeletePopupOpen(false);
			// Show Snackbar Alert
			handleClickSnackbar();
			// Snackbar Color Show
			setSeverity('error');
			try {
				const newData = await fetchLocations();
				setTimeout(() => {
					setOpenSnackbar(false);
				}, 2000);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setDeletePopupOpen(false);
		}
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	useEffect(() => {
		fetchLocations();
	}, []); // Call fetchLocations only once

	useEffect(() => {
		filterPracticeID(); // Filter Practice ID
	}, [locations]); // Call filterPracticeID when locations changeview
	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				xs={12}
				sm={12}
				md={12}
				lg={12}
				xl={12}
				border={'1px solid #0000003D'}
				borderRadius={'8px'}
			>
				{!loading && locations?.length === 0 ? (
					<Box
						width={'100%'}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						height={'50vh'}
						color={'#ED2828'}
						fontSize={'18px'}
					>
						Add hospital name to proceed !
					</Box>
				) : (
					''
				)}
				{loading ? (
					<Box
						width={'100%'}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						height={'50vh'}
					>
						<CircularProgress />
					</Box>
				) : (
					<Box
						sx={{
							width: '100%',
							overflowY: 'auto',
							height: {
								lg: '460px',
								sm: '440px',
								md: '450px',
								xs: '430px',
								xl: '550px',
							},
							'@media only screen and (max-width: 1920px) and (min-width: 1800px)':
								{
									// Styles for xs and sm screens
									height: '650px',
								},
							'@media only screen and (max-width: 820px) and (min-width: 700px)':
								{
									// Styles for xs and sm screens
									height: '600px',
								},
						}}
					>
						<Grid
							item
							container
							xs={12}
							lg={12}
							xl={12}
							md={12}
							sm={12}
							sx={{
								// border: ' 1px solid #00000026',
								padding: '25px 15px',
								// maxHeight: 500,
								'@media only screen and (max-width: 1200px) and (min-width: 1250px)':
									{
										// Styles for xs and sm screens
										padding: '5px',
									},
							}}
						>
							{filterPractice?.map((items, index) => {
								return (
									<Grid
										item
										xs={12}
										lg={3}
										xl={3}
										md={4.5}
										sm={4.5}
										key={index}
										sx={{
											margin: '15px 30px',
											// width: '170px',

											'@media only screen and (max-width: 1200px) and (min-width: 1250px)':
												{
													// Styles for xs and sm screens
													margin: '10px',
												},
										}}
									>
										<Box
											sx={{
												borderRadius: '8px',
												boxShadow: '0px 1px 4px 0px #00000040',
												padding: '5px',
												position: 'relative',
												textAlign: 'center',
												width: '240px',
												height: '68px',
											}}
										>
											<img
												src={hospitalimg}
												alt={`Hospital Icon`}
												style={{
													borderRadius: '5px',
													position: 'absolute',
													top: '-20px',
													right: '40%',
												}}
											/>

											<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
												<IconButton
													aria-label="more"
													id={`long-button-${index}`}
													aria-expanded={anchorEl ? 'true' : undefined}
													aria-haspopup="true"
													// onClick={handleClick}
													onClick={(event) => handleClick(event, index, items)}
												>
													<MoreVertIcon />
												</IconButton>
												<Menu
													id={`long-menu-${index}`}
													MenuListProps={{
														'aria-labelledby': `long-button-${index}`,
													}}
													anchorEl={anchorEl}
													// open={Boolean(anchorEl)}
													open={selectedIndex === index && Boolean(anchorEl)}
													onClose={handleClose}
													PaperProps={{
														elevation: 0,
														style: {
															boxShadow: '0px 1px 1px 0px #00000040',
															borderRadius: '10px',
														},
													}}
												>
													{/* Add menu options if needed */}
													<MenuItem
														selected={false}
														style={{
															color: 'black',
															fontFamily: 'Poppins',
															fontSize: '13px',
														}}
														onClick={() => handleEditData(items)}
													>
														Edit
													</MenuItem>
													<MenuItem
														selected={false}
														style={{
															color: '#ED2828',
															fontFamily: 'Poppins',
															fontSize: '13px',
														}}
														// onClick={() => { handleDelete(items?.id,deleteStatus) }}
														onClick={() => handleDelete(items)}
													>
														Delete
													</MenuItem>
												</Menu>
											</Box>
											<Typography
												variant="body2"
												sx={{
													fontFamily: 'Poppins',
													fontSize: '14px',
													fontWeight: '400',
													lineHeight: '21px',
													textOverflow: 'ellipsis',
													whiteSpace: 'nowrap',
													overflow: 'hidden',
												}}
											>
												<Tooltip title={`${items?.Name}`}>
													{items?.Name}
												</Tooltip>
											</Typography>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				)}

				{/* Add Hospital*/}

				<Modal
					open={props?.openModalIntialy == 'openModal' ? true : open}
					// onClose={handleCloseModal}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Box
							sx={{
								width: '100%',
								height: '65px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderBottom: '1px solid #00000070',
							}}
						>
							<Typography
								sx={{
									width: '88%',
									fontFamily: 'Poppins',
									fontSize: '32px',
									fontWeight: 500,
									textAlign: 'center',
								}}
							>
								Add Hospital
							</Typography>
							<IconButton
								onClick={() => {
									setOpen(false);
									setLocation({
										Name: '',
										practice_id: practice_id,
										Type: ' ',
										NPI: '',
										Contact: '',
										Address: '',
										City: '',
										State: '',
										Zip: '',
									});
									setErrors({});
									if (props?.openModalIntialy == 'openModal') {
										props?.renderHandleFromChild('hospital');
									}
								}}
							>
								<CancelIcon sx={{ fontSize: '30px' }} color="error" />
							</IconButton>
						</Box>
						<Grid container lg={12} xs={12} md={12} sm={12} p={3}>
							<Grid
								item
								lg={6}
								xs={6}
								md={6}
								sm={6}
								sx={{ padding: ' 10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Hospital Name<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									error={fieldRequiredError && location.Name == ''}
									size="small"
									value={location?.Name}
									onChange={handleInputChange}
									name="Name"
									type="text"
									fullWidth
									disableUnderline
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.Name && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Name}
									</div>
								)}{' '}
							</Grid>
							<Grid
								item
								lg={6}
								xs={6}
								md={6}
								sm={6}
								sx={{ padding: ' 10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									NPI<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									error={fieldRequiredError && location.NPI == ''}
									size="small"
									value={location?.NPI}
									onChange={handleInputChange}
									name="NPI"
									type="text"
									fullWidth
									disableUnderline
									inputProps={{ min: '0' }}
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.NPI && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.NPI}
									</div>
								)}{' '}
								{/* Display validation error */}
							</Grid>
							<Grid item lg={6} xs={6} md={6} sm={6} sx={{ padding: '5px' }}>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Type<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									error={fieldRequiredError && location.Type == ''}
									size="small"
									value={location?.Type}
									onChange={handleInputChange}
									name="Type"
									fullWidth
									disableUnderline
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.Type && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Type}
									</div>
								)}{' '}
								{/* Display validation error */}
							</Grid>
							<Grid item lg={6} xs={6} md={6} sm={6} sx={{ padding: '5px' }}>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Contact<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<MaskedInput
									required
									value={location?.Contact}
									onChange={handleInputChange}
									name="Contact"
									mask={[
										'(',
										/\d/,
										/\d/,
										/\d/,
										')',
										' ',
										/\d/,
										/\d/,
										/\d/,
										'-',
										/\d/,
										/\d/,
										/\d/,
										/\d/,
									]}
									style={{
										width: '100%',
										borderRadius: '6px',
										height: '40px',
										marginBottom: '8px',
										// marginTop: '8px',
										border: `${fieldRequiredError && location.Contact == '' ? '1px solid #d61b1b' : '1.5px solid #DDE6F1'}`,
										padding: '5px 0px 5px 6px',

										outlineColor: '#f3a765',
										boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
									}}
								/>
								{errors.Contact && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Contact}
									</div>
								)}{' '}
								{/* Display validation error */}
							</Grid>
							<Grid
								item
								lg={12}
								xs={12}
								md={12}
								sm={12}
								xl={12}
								sx={{ padding: '5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Address
								</InputLabel>
								<TextField
									size="small"
									value={location?.Address}
									onChange={(e) =>
										setLocation((prev) => ({
											...prev,
											Address: e.target.value,
										}))
									}
									name="address"
									type="text"
									fullWidth
									disableUnderline
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
							</Grid>
							<Grid
								item
								lg={4}
								xs={4}
								md={4}
								sm={4}
								xl={4}
								sx={{ padding: '5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									City<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									error={fieldRequiredError && location.City == ''}
									size="small"
									value={location?.City}
									onChange={handleInputChange}
									name="City"
									type="text"
									fullWidth
									disableUnderline
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.City && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.City}
									</div>
								)}{' '}
								{/* Display validation error */}
							</Grid>
							<Grid
								item
								lg={4}
								xs={4}
								md={4}
								sm={4}
								xl={4}
								sx={{ padding: '5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									State<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									error={fieldRequiredError && location.State == ''}
									size="small"
									value={location?.State}
									onChange={handleInputChange}
									name="State"
									type="text"
									fullWidth
									disableUnderline
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.State && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.State}
									</div>
								)}{' '}
								{/* Display validation error */}
							</Grid>
							<Grid
								item
								lg={4}
								xs={4}
								md={4}
								sm={4}
								xl={4}
								sx={{ padding: '5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Zip<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									error={fieldRequiredError && location.Zip == ''}
									size="small"
									value={location?.Zip}
									onChange={handleInputChange}
									name="Zip"
									type="text"
									fullWidth
									disableUnderline
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.Zip && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Zip}
									</div>
								)}{' '}
								{/* Display validation error */}
							</Grid>
							<Box
								mt={1}
								width={'100%'}
								height={'70px'}
								display={'flex'}
								justifyContent={'center'}
								gap={2}
							>
								<Button
									onClick={() => {
										setOpen(false);
										setLocation({
											Name: '',
											practice_id: practice_id,
											Type: ' ',
											NPI: '',
											Contact: '',
											Address: '',
											City: '',
											State: '',
											Zip: '',
										});
										setErrors({});
										if (props?.openModalIntialy == 'openModal') {
											props?.renderHandleFromChild('hospital');
										}
									}}
									style={{
										backgroundColor: '#ED2828',
										width: '151px',
										height: '52px',
										borderRadius: '7px',
										color: '#FFFFFF',
										fontSize: '20px',
									}}
								>
									Cancel
								</Button>
								<Button
									style={{
										backgroundColor: '#00A2E8',
										width: '151px',
										height: '52px',
										borderRadius: '7px',
										color: '#FFFFFF',
										fontSize: '20px',
									}}
									onClick={() => addlocationData()}
								>
									Add
								</Button>
							</Box>
						</Grid>
					</Box>
				</Modal>

				{/* Edit Modal */}

				<Modal
					open={editOpen}
					// onClose={editClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box
						style={style}
						sx={{
							width: {
								xs: '60%',
								sm: '50%',
								md: '40%',
								lg: '40%',
								xl: '40%',
							},
						}}
					>
						<Box
							sx={{
								width: '100%',
								height: '65px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderBottom: '1px solid #00000070',
							}}
						>
							<Typography
								sx={{
									width: '88%',
									fontFamily: 'Poppins',
									fontSize: {
										xs: '15px',
										sm: '20px',
										md: '32px',
										lg: '32px',
										xl: '32px',
									},
									// '32px',
									fontWeight: 500,
									textAlign: 'center',
								}}
							>
								Edit Hospital
							</Typography>
							<IconButton
								onClick={() => {
									setErrors({});
									setEditOpen(false);
								}}
							>
								<CancelIcon sx={{ fontSize: '30px' }} color="error" />
							</IconButton>
						</Box>
						<Grid container lg={12} xs={12} md={12} sm={12} p={3}>
							<Grid
								item
								lg={6}
								xs={6}
								md={6}
								sm={6}
								sx={{ padding: '10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Hospital Name<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									size="small"
									name="Name"
									type="text"
									fullWidth
									disableUnderline
									value={editData?.Name}
									onChange={handleEditModal}
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.Name && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Name}
									</div>
								)}
							</Grid>
							<Grid
								item
								lg={6}
								xs={6}
								md={6}
								sm={6}
								sx={{ padding: '10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									NPI<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									size="small"
									name="NPI"
									type="text"
									fullWidth
									disableUnderline
									value={editData?.NPI}
									onChange={handleEditModal}
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.NPI && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.NPI}
									</div>
								)}
							</Grid>
							<Grid
								item
								lg={6}
								xs={6}
								md={6}
								sm={6}
								sx={{ padding: '10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Type<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									size="small"
									name="Type"
									fullWidth
									disableUnderline
									value={editData?.Type}
									onChange={handleEditModal}
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.Type && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Type}
									</div>
								)}
							</Grid>
							<Grid
								item
								lg={6}
								xs={6}
								md={6}
								sm={6}
								sx={{ padding: '10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Contact<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<MaskedInput
									required
									value={editData?.Contact}
									onChange={handleEditModal}
									name="Contact"
									mask={[
										'(',
										/\d/,
										/\d/,
										/\d/,
										')',
										' ',
										/\d/,
										/\d/,
										/\d/,
										'-',
										/\d/,
										/\d/,
										/\d/,
										/\d/,
									]}
									style={{
										width: '100%',
										borderRadius: '6px',
										height: '40px',
										marginBottom: '8px',
										// marginTop: '8px',
										border: '1.5px solid #DDE6F1',
										padding: '5px 0px 5px 6px',

										outlineColor: '#f3a765',
										boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
									}}
								/>
								{errors.Contact && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Contact}
									</div>
								)}
							</Grid>
							<Grid
								item
								lg={12}
								xs={12}
								md={12}
								sm={12}
								xl={12}
								sx={{ padding: '10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Address
								</InputLabel>
								<TextField
									size="small"
									name="Address"
									type="text"
									fullWidth
									disableUnderline
									value={editData?.Address}
									onChange={targetEditModal}
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
							</Grid>
							<Grid
								item
								lg={4}
								xs={4}
								md={4}
								sm={4}
								xl={4}
								sx={{ padding: '10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									City<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									size="small"
									name="City"
									type="text"
									fullWidth
									disableUnderline
									value={editData?.City}
									onChange={handleEditModal}
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.City && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.City}
									</div>
								)}
							</Grid>
							<Grid
								item
								lg={4}
								xs={4}
								md={4}
								sm={4}
								xl={4}
								sx={{ padding: '10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									State<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									size="small"
									name="State"
									type="text"
									fullWidth
									disableUnderline
									value={editData?.State}
									onChange={handleEditModal}
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.State && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.State}
									</div>
								)}
							</Grid>
							<Grid
								item
								lg={4}
								xs={4}
								md={4}
								sm={4}
								xl={4}
								sx={{ padding: '10px 5px' }}
							>
								<InputLabel
									sx={{
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '500',
										textAlign: 'left',
										color: 'black',
									}}
								>
									Zip<span style={{ color: '#d61b1b' }}>*</span>
								</InputLabel>
								<TextField
									size="small"
									name="Zip"
									type="text"
									fullWidth
									disableUnderline
									value={editData?.Zip}
									onChange={handleEditModal}
									sx={{
										boxShadow: '0px 1px 10px 0px #79ACF178 inset',
										borderRadius: '4px',
									}}
								/>
								{errors.Zip && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.Zip}
									</div>
								)}
							</Grid>
							<Box
								mt={1}
								width={'100%'}
								height={'70px'}
								display={'flex'}
								justifyContent={'center'}
								gap={2}
							>
								<Button
									onClick={() => {
										setErrors({});
										setEditOpen(false);
									}}
									style={{
										backgroundColor: '#ED2828',
										// width: '151px',
										// height: '52px',
										borderRadius: '7px',
										color: '#FFFFFF',
										// fontSize: '20px',
									}}
									sx={{
										fontSize: {
											xs: '11px',
											sm: '11px',
											md: '14px',
											lg: '14px',
											xl: '14px',
										},
										width: {
											xs: '120px',
											sm: '120px',
											md: '151px',
											lg: '151px',
											xl: '151px',
										},
										height: {
											xs: '45px',
											sm: '45px',
											md: '52px',
											lg: '52px',
											xl: '52px',
										},
									}}
								>
									Cancel
								</Button>
								<Button
									disabled={
										errors?.Zip ||
										errors?.Type ||
										errors?.State ||
										errors?.Name ||
										errors?.NPI ||
										errors?.Contact ||
										errors?.City
									}
									style={{
										backgroundColor: `${errors?.Zip || errors?.Type || errors?.State || errors?.Name || errors?.NPI || errors?.Contact || errors?.City ? 'grey' : '#00A2E8'}`,
										// width: '151px',
										// height: '52px',
										borderRadius: '7px',
										color: '#FFFFFF',
										// fontSize: '20px',
									}}
									sx={{
										fontSize: {
											xs: '11px',
											sm: '11px',
											md: '14px',
											lg: '14px',
											xl: '14px',
										},
										width: {
											xs: '120px',
											sm: '120px',
											md: '151px',
											lg: '151px',
											xl: '151px',
										},
										height: {
											xs: '45px',
											sm: '45px',
											md: '52px',
											lg: '52px',
											xl: '52px',
										},
									}}
									onClick={() => UpdateModalValues(editDataObj)}
								>
									Update
								</Button>
							</Box>
						</Grid>
					</Box>
				</Modal>
			</Grid>

			{/*Delete Dialog Structure */}

			<Dialog
				fullScreen={fullScreen}
				open={deletePopupOpen}
				onClose={handleDialogClose}
				aria-labelledby="responsive-dialog-title"
				PaperProps={{
					style: { borderRadius: 8 },
				}}
			>
				<DialogTitle
					id="responsive-dialog-title"
					sx={{
						width: '100%',
						height: '80px',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						borderBottom: '1px solid #00000070',
					}}
				>
					<Typography
						width={'85%'}
						textAlign="center"
						sx={{
							fontFamily: 'Poppins',
							fontWeight: '600',
							fontSize: '32px',
						}}
					>
						{' '}
						Delete Hospital{' '}
					</Typography>

					<IconButton
						sx={{ width: '5%' }}
						size="small"
						onClick={deleteCancelPopup}
					>
						<CancelIcon color="error" sx={{ fontSize: '30px' }} />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<Typography
						textAlign="center"
						sx={{
							fontFamily: 'Poppins',
							fontWeight: '500',
							fontSize: '25px',
						}}
					>
						{' '}
						Are you sure to delete this Hospital?
					</Typography>
					<Typography
						textAlign="center"
						sx={{
							fontFamily: 'Poppins',
							fontWeight: '600',
							fontSize: '25px',
							color: '#075AD7',
						}}
					>
						{deleteUser} ?
					</Typography>
					<br />
					<Grid container spacing={2} align="center">
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
							<Button
								style={{
									backgroundColor: '#ED2828',
									width: '151px',
									height: '52px',
									borderRadius: '7px',
									color: '#FFFFFF',
									fontSize: '20px',
								}}
								onClick={deleteCancelPopup}
							>
								No
							</Button>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
							<Button
								style={{
									backgroundColor: '#00A2E8',
									width: '151px',
									height: '52px',
									borderRadius: '7px',
									color: '#FFFFFF',
									fontSize: '20px',
								}}
								onClick={() => {
									handleDeleteObj(deleteID, deleteStatus);
								}}
							>
								Yes
							</Button>
						</Grid>
					</Grid>
					{/* <Grid container spacing={2} align="center">
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
							<Button
								style={{ backgroundColor: '#ED2828', width: '75%' }}
								variant="contained"
								size="small"
								autoFocus
								onClick={deleteCancelPopup}
							>
								No
							</Button>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
							<Button
								style={{ backgroundColor: '#FD7702', width: '75%' }}
								variant="contained"
								size="small"
								onClick={() => {
									handleDeleteObj(deleteID, deleteStatus);
								}}
								autoFocus
							>
								Yes
							</Button>
						</Grid>
					</Grid> */}
				</DialogContent>
			</Dialog>

			{/* Show Snackbar After Deletion */}

			<Snackbar
				open={openSnackbar}
				onClose={handleCloseSnackbar}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'center',
				}}
			>
				<Alert
					onClose={handleCloseSnackbar}
					// severity="error"
					severity="success"
					variant="filled"
					sx={{
						width: '100%',
						// height: '4rem',
						textAlign: 'center',
						fontSize: '13px',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={() => {
									handleCloseSnackbar();
								}}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '16px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{severity === 'success'
						? 'Hospital Record Added Successfully !'
						: severity === 'info'
							? 'Hospital Record Updated Successfully !'
							: severity === 'error'
								? 'Hospital Record Deleted Successfully !'
								: ''}
				</Alert>
			</Snackbar>
			{/* Fill All Fields Snackbar */}
			<Snackbar
				autoHideDuration={1500}
				open={fieldRequiredError}
				onClose={() => setFieldRequiredError(false)}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'center',
				}}
			>
				<Alert
					onClose={() => setFieldRequiredError(false)}
					severity="error"
					variant="filled"
					sx={{
						width: '100%',
						// height: '4rem',
						textAlign: 'center',
						fontSize: '13px',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					Please Fill All Required Fields
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default HospitalList;
